import { Injectable } from '@angular/core';
import { MyProfile, MyProfileDto, UpdateMyProfilePayload } from '../../models/auth/my-profile.model';

@Injectable({
  providedIn: 'root',
})
export class MapperMyProfileService {
  mapFromDto(dto: MyProfileDto): MyProfile {
    const raw = dto as MyProfileDto & Record<string, unknown>;
    return {
      id: Number(raw.id ?? raw['Id'] ?? 0),
      login: String(raw.login ?? raw['Login'] ?? ''),
      displayName: String(raw.displayName ?? raw['DisplayName'] ?? ''),
      email: String(raw.email ?? raw['Email'] ?? ''),
      phone: String(raw.phone ?? raw['Phone'] ?? ''),
      hasCityPassword: !!(raw.hasCityPassword ?? raw['HasCityPassword'] ?? false),
      roleName: String(raw.roleName ?? raw['RoleName'] ?? ''),
    };
  }

  mapUpdatePayload(form: { displayName: string; email: string; phone: string }): UpdateMyProfilePayload {
    return {
      displayName: form.displayName.trim(),
      email: form.email.trim() || null,
      phone: form.phone.trim() || null,
    };
  }
}
